export default class StatusError extends Error {
  readonly response: object;

  constructor(response: { message?: string; [key: string]: any }) {
    super(response.message);
    this.response = response;
  }
}
